export default __webpack_public_path__ + "img/ykBXQOYQ.ffb5937e.svg";